enum Align {
  left = 'left',
  center = 'center',
  right = 'right',
}

export default Align;
